<template>
  <md-card>
    <md-card-content>
      <div :class="'md-layout'">
        <div
          :class="'md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 graph-container'"
          :style="'max-height: 80%'"
        >
          <div :class="'md-display-1 text-center'">Standard</div>
          <BarChart
            :height="relativeHeight"
            :graphData="barChartData"
            v-if="hasBarChartData"
          />
          <md-empty-state
            md-icon="bar_chart"
            md-label="Empty graph"
            md-description="Not enough data to plot by graph standard"
            v-else
          >
          </md-empty-state>
        </div>
        <div
          :class="'md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50 graph-container'"
          :style="'max-height: 80%'"
        >
          <div :class="'md-display-1 text-center'">Overall</div>
          <PieChart
            :height="relativeHeight"
            :graphData="overallGraphData"
            v-if="hasOverallGraphData"
          />
          <md-empty-state
            md-icon="pie_chart"
            md-label="Empty graph"
            md-description="Not enough data to plot overall standard graph"
            v-else
          >
          </md-empty-state>
        </div>
        <div
          :class="'md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50 graph-container '"
          :style="'max-height: 80%'"
        >
          <div :class="'md-display-1 text-center'">Standard</div>
          <PieChart
            :height="relativeHeight"
            :graphData="standardGraphData"
            v-if="hasStandardGraphData"
          />
          <md-empty-state
            md-icon="pie_chart"
            md-label="Empty graph"
            md-description="Not enough data to plot standard graph"
            v-else
          >
          </md-empty-state>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import "chartjs-plugin-datalabels";
import PieChart from "./PieChart.vue";
import BarChart from "./BarChart.vue";

export default {
  props: {
    overallGraphData: {
      type: Object,
      default: () => {},
      required: false,
    },

    standardGraphData: {
      type: Object,
      default: () => {},
      required: false,
    },

    barChartData: {
      type: Object,
      default: () => {},
      required: false,
    },
  },

  computed: {
    hasBarChartData() {
      return this.barChartData.datasets.find(
        (dataset) => dataset.data.reduce((initial, data) => initial + data) > 0
      )
        ? true
        : false;
    },

    hasOverallGraphData() {
      return this.overallGraphData.data.find((data) => data > 0) ? true : false;
    },

    hasStandardGraphData() {
      return this.standardGraphData.data.find((data) => data > 0)
        ? true
        : false;
    },

    relativeHeight() {
      const actualHeight = window.innerHeight / 4;
      return actualHeight > 200 ? 200 : actualHeight;
    },
  },

  components: {
    PieChart,
    BarChart,
  },
};
</script>
